// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"255":"4d818bc3","658":"6300f206"}[chunkId] + ".chunk.css";
};